import gql from 'graphql-tag';

export const RETRIEVE_PASSWORD = gql`
  mutation ($input: ForgotPasswordInput!){
    retrievePassword(input: $input) {
      status
      message
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/auth/retrieve.js